import React, { PureComponent } from 'react';
import styled from 'styled-components';
import Button from '@atlaskit/button';
import DynamicTable from '@atlaskit/dynamic-table';
import Tooltip from '@atlaskit/tooltip';

class CarsForm extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 1,
      sortKey: '',
      sortOrder: 'DESC',
      sortedCars: [],
    };
  }

  componentDidMount() {
    this.sortCars();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.cars !== this.props.cars ||
      prevState.sortKey !== this.state.sortKey ||
      prevState.sortOrder !== this.state.sortOrder
    ) {
      this.sortCars();
    }
  }

  sortCars = () => {
    const { cars } = this.props;
    const { sortKey, sortOrder } = this.state;

    if (!cars || cars.length === 0) {
      this.setState({ sortedCars: [] });
      return;
    }

    const sorted = [...cars].sort((a, b) => {
      const aValue = a[sortKey] ? a[sortKey].toString().toLowerCase() : '';
      const bValue = b[sortKey] ? b[sortKey].toString().toLowerCase() : '';

      if (aValue < bValue) return sortOrder === 'ASC' ? -1 : 1;
      if (aValue > bValue) return sortOrder === 'ASC' ? 1 : -1;
      return 0;
    });

    this.setState({ sortedCars: sorted });
  };

  onSort = ({ key, sortOrder }) => {
    this.setState({
      sortKey: key,
      sortOrder: sortOrder === 'ASC' ? 'ASC' : 'DESC',
      currentPage: 1,
    });
  };

  render() {
    const { cars, notFoundCarVins } = this.props;
    const { currentPage, sortedCars } = this.state;

    if (!cars || cars.length === 0) {
      if (notFoundCarVins && notFoundCarVins.length > 0) {
        return (<CarsContainer>
        <Header>
          <Title>Не найдено ({notFoundCarVins.length}) автомобилей</Title>
          <ButtonGroup>
            {notFoundCarVins && notFoundCarVins.length > 0 && (
              <Tooltip content={notFoundCarVins.join(', ')} position="top">
                <Button
                  appearance="warning"
                  onClick={() => {
                    navigator.clipboard.writeText(notFoundCarVins.join('\n'));
                  }}
                >
                  Скопировать не найденные VIN ({notFoundCarVins.length})
                </Button>
              </Tooltip>
            )}
          </ButtonGroup>
        </Header>
      </CarsContainer>)
      }

      return null;
    }

    const itemsPerPage = 10;


    const totalPages = Math.ceil(sortedCars.length / itemsPerPage);
    const paginatedCars = sortedCars.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );

    const head = {
      cells: [
        { key: 'vin', content: 'VIN', isSortable: true, width: 20, shouldTruncate: true },
        { key: 'make', content: 'Марка', isSortable: true, width: 15, shouldTruncate: true },
        { key: 'model', content: 'Модель', isSortable: true, width: 15, shouldTruncate: true },
        { key: 'year', content: 'Год', isSortable: true, width: 10, shouldTruncate: true },
        { key: 'colorName', content: 'Цвет', isSortable: true, width: 20, shouldTruncate: true },
        { key: 'version', content: 'Версия', isSortable: true, width: 10, shouldTruncate: true },
        { key: 'body', content: 'Кузов', isSortable: true, width: 15, shouldTruncate: true },
      ],
    };

    const rows = paginatedCars.map((car) => ({
      key: car.Id,
      cells: [
        { content: car.vin || '', truncateContent: true },
        { content: car.make || '', truncateContent: true },
        { content: car.model || '', truncateContent: true },
        { content: car.year || '', truncateContent: true },
        { content: car.colorName || '', truncateContent: true },
        { content: car.version || '', truncateContent: true },
        { content: car.body || '', truncateContent: true },
      ],
    }));

    return (
      <CarsContainer>
        <Header>
          <Title>Список автомобилей ({cars.length})</Title>
          <ButtonGroup>
            {notFoundCarVins && notFoundCarVins.length > 0 && (
              <Tooltip content={notFoundCarVins.join(', ')} position="top">
                <Button
                  appearance="warning"
                  onClick={() => {
                    navigator.clipboard.writeText(notFoundCarVins.join('\n'));
                  }}
                >
                  Скопировать не найденные VIN ({notFoundCarVins.length})
                </Button>
              </Tooltip>
            )}
          </ButtonGroup>
        </Header>
        <DynamicTable
          head={head}
          rows={rows}
          loadingSpinnerSize="large"
          isLoading={false}
          isFixedSize={true}
          defaultSortKey={this.state.sortKey}
          defaultSortOrder={this.state.sortOrder}
          onSort={this.onSort}
        />

        <PaginationControls>
          <Button
            isDisabled={currentPage === 1}
            appearance="subtle"
            onClick={() => this.setState({ currentPage: currentPage - 1 })}
          >
            Предыдущая
          </Button>
          <PageInfo>
            Страница {currentPage} из {totalPages}
          </PageInfo>
          <Button
            isDisabled={currentPage === totalPages}
            appearance="subtle"
            onClick={() => this.setState({ currentPage: currentPage + 1 })}
          >
            Следующая
          </Button>
        </PaginationControls>
      </CarsContainer>
    );
  }
}

const CarsContainer = styled.div`
  margin-top: 24px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const Title = styled.h4`
  margin: 0;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`;

const PaginationControls = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
`;

const PageInfo = styled.span`
  margin: 0 16px;
`;

export default CarsForm;
